const zh = {
  translation: {
    //home
    home: "主页",
    vehicles: "车辆",
    sign_in: "登录",
    plan_you_trip: "计划您的行程",
    save_big: "通过我们经济实惠的租车服务节省大笔开支！",
    with_our_car: "通过我们的经济型租车！",
    save_big_desc: "租用您梦寐以求的汽车。无可比拟的价格，不限里程，灵活的取车选项等等。",
    book_ride: "预订乘车",
    learn_more: "了解更多",
    book_a_car: "预订一辆车",
    without_driver: "无司机",
    with_driver: "与司机",
    select_booking_type: "选择预订类型",
    self_drive: "自驾",
    tour: "旅行/日租",
    transfer_service: "接送服务",
    pickup_date: "取车日期",
    dropoff_date: "还车日期",
    pickup_location: "取车地点",
    dropoff_location: "还车地点",
    book_now: "立即预订",
    the_price_exclude: "价格不包括司机费用，将额外收费",
    select_tour_package: "选择旅行套餐",
    select_duration: "选择时长",
    destination_location: "目的地位置",
    quick_and_easy: "快速简便的租车",
    select_car: "选择车辆",
    we_offer: "我们提供各种类型的车辆，满足您的所有驾驶需求。我们有完美的车辆来满足您的需求",
    contact_operator: "联系运营商",
    our_knowlage: "我们知识渊博而友好的运营商随时为您提供帮助",
    let_drive: "让我们驾驶",
    whether_you: "无论您是否在开放道路上行驶，我们都为您提供了广泛的汽车选择",
    vehicle_models: "车型",
    our_rental_fleet: "我们的租赁车队",
    choose_from: "选择我们惊人的各种车辆中的一辆，为您的下一个冒险或商务旅行租赁",
    reserve_now: "立即预订",
    save_big_bottom: "使用我们的廉价租车，大大节省费用！",
    top_airport: "顶级机场。本地供应商。 ",
    support: "支持",
    why_choose_use: "为什么选择我们",
    best_valued: "您将找到的最佳交易",
    discover_the_best:
      "发现您永远找不到的最佳交易，与我们无法比拟的优惠。我们致力于为您提供物有所值，让您享受高质量的服务和产品，而不会损害财务状况。我们的交易旨在为您提供最终的租赁体验，所以不要错过节省大量费用的机会。",
    find_details: "查找详细信息",
    cross_city: "穿越城市之旅",
    take_your_driving: "通过我们一流的车辆，将您的驾驶体验提升到一个新的水平，享受跨国家的冒险。",
    all_inclusive: "一切包含的价格",
    get_everything: "使用我们的一切包含的价格政策，您可以获得一切所需的东西，价格透明，方便。",
    no_hidden: "无隐藏费用",
    enjoy_peace: "通过我们的无隐藏费用政策，享受心灵的宁静。我们坚信透明和诚实的定价。",
    review_by_people: "人们的评论",
    client_testimonial: "客户的证言",
    client_testimonial_desc:
      "通过阅读客户的证言，了解我们对客户产生的积极影响。我们的客户已经体验了我们的服务和结果，他们渴望与您分享他们的积极经验。",
    testi_aris:
      "我真的很喜欢它。服务就像司机准时到达并知道路线一样酷。非常高兴，这项服务真的很棒。汽车也是如此。气味清新，一切都进行得很顺利。让Mas Yoyok（司机）成功和健康，那么...对于租车企业家来说，我不想再说什么了。因为没有抱怨。总之，成功。",
    testi_solomon:
      "我租了一辆Avanza，2016年G型。车辆没有问题，发动机平稳，车身整洁注册，最重要的是，当您租车时，WA团队/团队立即准备好了...要求的文件...这很酷。最重要的是。",
    faq: "常见问题",
    frequently_asked: "常见问题",
    frequently_asked_desc: "关于我们网站上的汽车租赁预订流程的常见关切和问题的回答。",
    what_is_special: "1. 比较租车交易有什么特别之处？",
    what_is_special_desc:
      "比较租车交易很重要，因为它有助于找到适合您的预算和要求的最佳交易，确保您获得最大的价值。通过比较不同选项，您可以找到提供更低价格、附加服务或更好车型的交易。您可以通过在线研究并比较来自不同租车公司的价格来找到汽车租赁交易。",
    how_do_2: "2. 如何找到租车交易？",
    how_do_2_desc:
      "您可以通过在线研究并比较来自不同租车公司的价格来找到汽车租赁交易。网站如Expedia、Kayak和Travelocity允许您比较价格并查看可用的租赁选项。此外，建议您注册电子邮件通讯和关注租车公司的社交媒体，以获取特别交易或促销的信息。",
    how_do_3: "3. 如何找到如此低廉的租车价格？",
    how_do_3_desc:
      "预订提前：提前预订租车往往可以获得更低的价格。从多家公司比较价格：使用网站如Kayak、Expedia或Travelocity比较多家租车公司的价格。寻找折扣代码和优惠券：搜索可用于降低租金价格的折扣代码和优惠券。有时从机场以外的位置租车可以获得更低的价格。",
    reservation_12: "预订必须提前至少12小时",
    reservation_24: "预订必须提前至少24小时",
    drop_after_pickup: "退车日期必须在取车日期之后",
    //car_card
    daily_rate_from: "每日费率从",
    includes: "包括",
    isurances_etc: "保险、客户服务",
    more_info: "更多信息",
    efficient: "高效",
    safe: "安全",
    economical: "经济",
    //select vehicle
    book_car_by_getting: "通过与我们联系预订汽车",
    select_vehicle: "选择车辆",
    complete_reservation: "完成预订",
    upon_completing: "完成此预订查询后，您将收到：",
    your_rent_voucher: "您的租车凭证，需在租车柜台上出示，并附有免费客户支持电话。",
    location_n_date: "地点和日期",
    car: "汽车",
    pickup_date_n_time: "取车日期和时间",
    dropoff_date_n_time: "还车日期和时间",
    prices: "价格",
    additional_items: "附加项目",
    umbrella: "伞",
    baby_seat: "婴儿座椅",
    insurance: "保险",
    full_covered: "全保险",
    wedding: "婚车",
    flower_arrangement: "插花（婚车）",
    additional_stop: "额外停留",
    flower_bouquet: "花束",
    all_in_one_for: "过路费和停车费",
    price_estimate: "价格估算",
    estimate_total: "估算总价",
    the_price_does_not: "价格不包括通行费、停车费和小费。",
    the_price_includes: "价格包括汽油和单程停车费",
    personal_info: "个人信息",
    identity_type: "身份证明类型",
    select_identity: "选择身份证明",
    identity_image: "身份证明照片",
    choose_file: "选择文件",
    sim_or: "SIM卡 / 驾照",
    name: "姓名",
    booker_name: "预订人姓名",
    enter_booker_name: "输入订购者姓名",
    enter_name: "输入您的姓名",
    whatsapp_number: "WhatsApp号码",
    enter_whatsapp_number: "输入您的WhatsApp号码",
    email: "电子邮件",
    enter_email: "输入您的电子邮件地址",
    address: "地址",
    enter_address: "输入您的地址",
    emergency_contact_1: "紧急联系人1",
    emergency_contact_2: "紧急联系人2",
    enter_emergency: "输入您的紧急联系人",
    return_flight: "返程航班预订",
    hotel_accomodation: "住宿酒店",
    notes: "备注",
    enter_notes: "输入您的备注",
    we_will_ask: "如果需要，我们将索取额外的数据。",
    rental_policy: "租车政策",
    in_town_usage: "市内使用",
    add_outside_island: "添加岛外使用",
    outside_island_usage: "岛外使用",
    for_self_drive: "岛外自驾使用",
    denpasar_jimbaran_etc: "登巴萨，金巴兰，勒吉安，努沙杜瓦，乌鲁瓦图，乌布中心，塞米亚克。",
    out_of_town_usage: "市外使用",
    zone_1: "区域1",
    zone_2: "区域2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (fee depends on car type)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (fee depends on car type)",
    this_rate_valid: "此费率仅适用于单向。",
    add_out_off_town: "添加市外使用",
    select_date: "选择日期",
    select_travel_date: "选择城市之外的旅行日期",
    select_travel_date_island: "选择岛外的旅行日期",
    total: "总计",
    close: "关闭",
    add: "添加",
    loading: "加载中...",
    // customer form
    additional_information: "附加信息（可选）",
    guest_name: "客人姓名",
    driver_name: "司机姓名",
    passanger_total: "乘客总数",
    luggage_total: "行李总数",
    flight_detail: "航班详情",
    airline_name: "示例：航空公司名称：嘎鲁达，到达时间：17:00",
    hotel_detail: "酒店/住宿详情",
    hotel_name: "示例：酒店名称：印达酒店",
    disability_needs: "残疾需求",
    wheelchair: "示例：轮椅：1",
    the_price_varies: "价格根据目的地位置而异。",
    including_petrol: "包括 过路费和停车费",
    change: "更改",
    setting_date_use: "设置使用日期",
    date: "日期",
    //detail vehicle
    detail_vehicle: "车辆详情",
    price_type: "价格类型",
    price: "价格",
    area: "区域",
    yes: "是",
    trunk: "后备箱",
    customer_service: "客户服务",
    insurances: "保险",
    with_a_professional:
      "凭借专业和全面的售后服务，由于我们团队的良好支持，您可以放心休息。您还可以在订购此车时享受各种诱人的优惠和特别促销活动。",
    select_this_car: "选择此车",
    //global
    save: "节省",
    big: "大",
    days: "天",
    hour: "小时",
    brand: "品牌",
    year: "年",
    seat: "座位",
    ac: "空调",
    color: "颜色",
    transmission: "变速器",
    fuel: "燃料",
    company: "公司",
    working_hour: "工作时间",

    //privacy and policy
    privacy_and_police: "隐私政策与条款",
    for_overtime: "对于超时，将收取50,000印尼卢比/小时的费用（超过2小时计为1天租用）。",
    for_extension:
      "如果要延长租赁超过2次，请在我们的办公室确认和验证，地址为：Wirasana Rent A Car Denpasar，Jl. Bypass Ngurah Rai No.162，Sanur Kaja，南登巴萨。",
    unit_vehicles: "租赁的车辆不得转让/使用，除非签署租赁合同的租户（如果将车辆用作证据，则将收取每日租金费用）。",
    reschedule_or: "如果通知距离预定的行程不到1x24小时，将无法确认或更改提取/交付单位的重新安排，以避免操作设置错误。",
    reschedule_date: "如果要重新安排提取单位/交付单位的日期或时间，将收取75,000印尼卢比的费用（最多允许2次重新安排）。",
    for_lose_umbrella: "在租期内遗失伞将收取100,000印尼卢比/把伞的费用。",
    for_lose_baby_seat: "在租期内遗失婴儿汽车座椅将收取2,000,000印尼卢比/婴儿汽车座椅的费用。",
    usage_unit: "车辆仅限在巴厘岛地区使用。",
    lose_stnk: "遗失车辆注册证书将收取1,500,000印尼卢比的费用。",
    lose_plat: "遗失车牌将收取250,000印尼卢比的费用。",
    for_damage_ban: "由于不正确的使用/在非沥青道路上使用而造成的轮胎损坏将收取每个轮胎700,000印尼卢比的费用。",
    for_beret: "如果有新的划痕，将每次收取750,000印尼卢比的费用。",
    towing_fee: "拖车费用和在修理期间租赁汽车的租金不包括在自有风险费用中。",
    lack_of_petrol: "在交付或提取期间油箱缺少油将收取每箱100,000印尼卢比的费用。",
    fuel_in_the_middle: "如果在旅途中燃油不足，将对城市内的区域收取250,000印尼卢比的处理费。",
    smell: "如果在交车时汽车有榴莲/呕吐物/烟草/湿座椅的气味，将收取1,500,000印尼卢比的费用。",
    dirty_car: "如果汽车非常脏，将收取150,000印尼卢比的清洁费。",
    lost_the_key: "如果丢失汽车钥匙，将收取1,500,000印尼卢比的费用。",
    more_than_one_driver: "如果有多名司机，将每天收取50,000印尼卢比/ID的费用。",
    please_not_park: "请不要将车辆停放在树下或可能危及车辆位置的地方。",
    charging_error: "如果加油错误，将收取2,500,000印尼卢比的修理费。",
    not_info: "如果我们在租赁期间未收到与车辆维修需求相关的信息，我们将不会在未经同意/讨论的情况下从任何车间接受赔偿。",
    trouble_car: "如果车辆出现问题，我们的机械团队将尽力在最多4小时内与您联系并提供帮助（取决于您当时的位置）。",
    security_deposit:
      "500,000印尼卢比的押金将作为租赁期间的保证金保留（在车辆归还和E-Tilang检查后，最多7天内将通过银行转账退还押金）。",
    basic_usage: "基本使用仅限于根据Traveloka地图的城市内使用。",
    excess_usage: "超过12小时或晚上12点后的使用将根据Traveloka的附表/规定额外收费。",
    driver_contact: "当司机即将到达取车地点时，司机会与您联系。",
    other_questions: "如果您有其他问题，请随时与我们联系。",
    pickup_point: "在Solaria前有接送点,如果您希望请求不同的接送点,请直接通过这个群组通知我们.",
    reschedule_info: "如果通知提前不到预定时间的24小时,我们将无法确认有关接送和目的地更改的内容,以避免操作设置错误.",
    reschedule_fee: "重新安排费用为75,000印度尼西亚卢比(最多可以重新安排2次).",
    reschedule_airline:
      "由于航空公司更改而重新安排,请附上重新安排的证明,我们将确认,无需重新安排费用.然而,接送车辆的类型将取决于重新安排时间的车辆可用性.",
    airline_delay: "在航空公司延误的情况下,请提供延误的证明.我们的司机将尽最大努力按照最新的时间表接您.",
    voucher_usage: "凭证仅适用于不停留或单程接送一次.",
    additional_stop_meals: "额外停车(例如用餐等)将收取每小时100,000印度尼西亚卢比的额外费用.",
    driver_wait_time: "司机将等待30分钟.如果超过指定时间,将额外收取每小时100,000印度尼西亚卢比的费用.",
    destination_change: "目的地更改将根据地点额外收费.",
    no_eating_drinking: "不允许在车辆内进食和饮食,可能导致食物溅出.",
    boarding_landing: "请在登机和抵达Ngurah Rai机场后进行确认.",
    driver_details: "司机详情将在出发当天提供.",
    mask_and_distance: "请始终佩戴口罩并在车辆内保持社交距离.",
    disinfected_vehicles: "所有Wirasana车辆都已预先消毒.",
    SWAB_driver_charge: "如果需要,SWAB司机将额外收费99,000印度尼西亚卢比.",
    passenger: "乘客",
    use_the_current_location: "使用当前位置信息",
    cancel: "取消",
    confirm: "确认",
    i_have_read_and_accept: "我已阅读并接受隐私政策",
    i_accept_the_privacy: "我接受隐私政策",
    open_filters: "打开筛选",
    sort: "排序",
    price_low_to_high: "价格：从低到高",
    price_high_to_low: "价格：从高到低",
    name_a_z: "名称：A → Z",
    name_z_a: "名称：Z → A",
    filters: "筛选",
    price_per_day: "每日价格",
    total_passenger: "总乘客数",
    drivetrain: "驱动方式",
    clear_all: "清除所有",
    apply_filters: "应用筛选",
    search_car: "搜索车辆",
    ready_to_continue_payment: "准备继续付款了吗？",
    please_review_payment: "请在继续之前检查您的付款信息。",
    total_amount: "应付总额",
    proceed_to_payment: "继续付款",
    about: "关于我们",
    about_company: "公司简介",
    about_headline: "启动引擎，开启你的冒险之旅",
    about_description: "虽然简单，但我们致力于提供最优质的服务，让每一次旅程都舒适、安全且充满乐趣。",
    about_car_types: "车型",
    about_rental_outlets: "租赁网点",
    about_repair_shop: "维修中心",
    about_book_car: "联系我们预订车辆",
    about_phone: "(0361) 286-066",
    language: "语言",
    about_us: "关于我们",
    contact_us: "联系我们",
    booking_type: "预订类型",
    the_royal_essence: "旅程的皇家精髓",
    relaxed_journey: "最轻松的旅程",
    page_title: "联系",
    headline: "需要更多信息吗？",
    description: "一位在研究、开发和教育领域拥有超过15年经验的多才多艺的专业人士。",
    phone_label: "电话",
    email_label: "电子邮件",
    address_label: "地址",
    form_name: "全名",
    form_message: "告诉我们您的需求",
    form_placeholder_name: "例如: '张伟'",
    form_placeholder_message: "请在这里填写...",
    form_button: "通过 WhatsApp 发送",
    required_alert: "请填写所有必填字段！",
    address_value: "登巴萨，巴厘岛",
    why_choose_wirasana: "为什么选择 Wirasana",
    trusted_partner: "您在巴厘岛值得信赖的汽车租赁伙伴",
    experience_excellence: "通过我们的高端车队、卓越服务和无与伦比的价格，体验极致品质。",
    happy_customers: "满意客户",
    vehicles_available: "可用车辆",
    years_experience: "年经验",
    satisfaction_rate: "满意度",
    what_makes_us_different: "我们的独特之处",
    discover_advantages: "了解我们与竞争对手的不同之处",
    comprehensive_insurance: "全方位保险",
    comprehensive_insurance_desc: "每次租车都包含全面保险，让您安心驾驶。",
    premium_fleet: "高端车队",
    premium_fleet_desc: "现代化、保养良好的车辆，确保最佳驾驶体验。",
    support_247: "全天候支持",
    support_247_desc: "24小时客户服务，随时为您提供帮助。",
    best_price: "最优价格保证",
    best_price_desc: "透明定价，无隐藏费用，无意外支出。",
    flexible_rental: "灵活租期",
    flexible_rental_desc: "可选择按小时、天或月租赁，灵活适应您的行程。",
    free_delivery: "免费送车",
    free_delivery_desc: "在巴厘岛任意地点提供免费送车和取车服务。",
    more_reasons: "更多值得信赖的理由",
    trusted_by_thousands: "数千人信赖的选择",
    trusted_by_thousands_desc: "超过10,000名满意客户选择了我们。",
    licensed_insured: "合法且有保险保障",
    licensed_insured_desc: "我们的车队均持牌并投保，确保您的安全与安心。",
    easy_booking: "便捷预订流程",
    easy_booking_desc: "几分钟即可在线预订，无需复杂手续。",
    flexible_payment: "灵活付款方式",
    flexible_payment_desc: "支持信用卡、银行转账和数字钱包。",
    cta_title: "准备好开始您的旅程了吗？",
    cta_desc: "立即预订理想车辆，体验 Wirasana 的不同之处。",
    call_us_now: "立即致电我们",
    back: "后退",
    weather_protection: "户外活动的天气防护",
    safety_seat_children: "儿童安全座椅（5–4岁）",
    beautiful_flower_arrangements: "适合特殊场合的精美花卉布置",
    extra_stops: "旅途中额外停靠点",
    all_in_one_package: "一体化便利套餐",
    fresh_flower_bouquet: "鲜花花束布置",
    set_quantity_each_date: "为每个日期设置数量",
    total_items: "总项目",
    items: "项目",
    select_all: "全选",
    select_dates_apply_item: "选择要应用此项目的日期",
    item_will_be_applied: "项目将被应用",
    out_of: "共",
    total_day: "总天数",
    type_or_choose_location: "输入位置或从列表中选择...",
    select_from_map: "从地图上选择位置",
    popular_locations: "热门地点",
    manual_input_hint: "或在搜索框中手动输入位置",
    common: {
      back: "后退",
      back_to_search: "返回搜索",
      name: "姓名",
      email: "电子邮件",
      phone: "电话",
      total: "全部的",
      hours: "时间",
      processing: "加工...",
      searching: "正在寻找...",
      error_occurred: "发生错误。",
      information: "信息",
    },
    booking: {
      detail: "预订详情",
      booking_number: "预订#{{number}}",
      not_found: "未找到数据",
      search_again: "请再次搜索您的预订",
      type: "预订类型",
      pickup_date: "取货日期",
      dropoff_date: "还车日期",
      price_breakdown: "价格细目",
      price_date: "价格 （{{date}}）",
      fees: "交易费用和税收",
      delivery_fee: "运费",
      pickup_fee: "接机费",
      canceled: "订单已取消",
      contact_customer_service: "该订单已被取消。",
      check_history: "查看预订历史",
      enter_details: "输入您的电子邮件和预订代码以查看您的订单详细信息",
      booking_code: "预订代码",
      code_example: "示例：S-0018、T-0025（使用 S-0018 进行演示）",
      check_booking: "检查预订",
      info_code_sent: "预订后，预订代码将发送至您的电子邮件",
      info_continue_payment: "未付款订单您可以继续付款",
      info_contact_support: "如果遇到问题请联系客服",
    },
    status: {
      booked: "已预订",
      prepared: "准备好了",
      operated: "经营",
      canceled: "取消",
      success: "成功",
    },
    payment: {
      not_paid: "未付款",
      paid: "有薪酬的",
      partial: "部分付款",
      continue: "继续付款",
      invoice_not_found: "未找到发票",
      link_failed: "无法创建付款链接。",
      received: "已收到付款",
      total_paid: "支付总额： {{amount}}",
    },
    validation: {
      fill_all_fields: "请填写电子邮件和预订代码",
    },
    manage_booking: "管理预订",
    booking_confirmation: "预订确认",
    next: "下一个",
    booking_details: "预订详情",
    review_n_confirm: "审核并确认",
    booking_success: "预订成功！",
    booking_success_message: "您的预订已成功提交。",
    open_payment_link: "打开支付链接",
    required_documents: "所需文件",
    payment_information: "付款信息",
    review_payment_details: "请检查您的付款详细信息并继续付款",
    booking_summary: "预订摘要",
    invoice_number: "发票号码",
    customer_name: "客户名称",
    payment_instructions: "付款说明",
    payment_instruction_1: "点击下面的按钮创建付款发票",
    payment_instruction_2: "您将被重定向到 Xendit 付款页面",
    payment_instruction_3: "使用可用的付款方式完成付款",
    payment_instruction_4: "付款成功后您将收到确认邮件",
    payment_link_created: "付款链接已创建！",
    click_below_to_proceed: "点击下方按钮进行付款",
    creating_invoice: "正在创建发票...",
    create_payment_invoice: "创建付款发票",
    done: "我已完成付款",
    order_summary: "订单摘要",
    please_review_order: "请在继续付款前检查您的订单详情",
    customer_information: "客户信息",
    phone: "电话",
    vehicle: "车辆",
    rental_period: "租赁期限",
    locations: "地点",
    price_breakdown: "价格明细",
    base_price: "基础价格",
    delivery_fee: "送车费用",
    pickup_fee: "取车费用",
    tour_package: "旅游套餐价格从",
    airport_transfer_from: "机场接送服务价格从",
    tourPackage: "旅游套餐",
    basic_title: "基本防护",
    basic_subtitle: "您的租金包含基本保险",
    km_unlimited: "不限里程",
    own_risk: "每次事故自担风险费用为 Rp 750,000",
    damage_cover: "碰撞、划痕和冲击损坏的承保",
    glass_tire: "轮胎和玻璃保护",
    interior_protect: "内部防护",
    not_included_towing: "如果维修持续超过 7 天，则不包括拖车服务和额外租赁天数",
    got_it: "知道了",
    basic_protection: "基本防护",
    see_more_details: "查看更多详情",
    gps: "GPS",
    gps_desc: "车载导航系统。",
    phone_holder: "手机支架",
    phone_holder_desc: "用于安全驾驶的免提手机支架。",
    family_card: "家庭卡",
    business_id: "商业编号",
    social_media: "社交媒体",
    customer_info: "客户信息",
    enter_social_media: "输入社交媒体",
    insurance_subtitle: "保障您的旅程，全面保障，安心无忧",
    included: "包括",
    not_included: "不包括在内",
    toll_and_parking: "收费和停车",
    toll_and_parking_desc: "收费停车费用",
    your_trusted_mobility: "您在巴厘岛值得信赖的出行伙伴",
    wirasana_is_professional:
      "Wirasana Rent A Car 是一家位于巴厘岛的专业汽车租赁服务公司，致力于为旅行者和企业提供可靠、舒适且灵活的交通解决方案。凭借在交通行业多年的经验，我们深知出行是每段旅程中不可或缺的一部分——无论是休闲、商务还是特殊场合。",
    our_mission_is_to_make:
      "我们的使命是让巴厘岛的交通变得简单、安全且便捷。我们提供多种保养良好的车辆，以满足不同需求，从适合个人旅行的紧凑型汽车到适合商务和特殊活动的 premium 车辆。",
    lets_get_you: "让您即刻启程",
    have_questions_about:
      "对我们的车辆、价格或可用性有疑问吗？我们的团队随时准备为您提供帮助。无论您是计划在巴厘岛度假、商务旅行还是参加特殊活动，我们都会让您的交通体验顺畅无忧。",
    search_vehicle: "搜索车辆",
    vehicle_type: "车辆类型",
    motorcycle: "摩托车",
    all: "全部",
    your_trustedcar_rental_in_bali: "您在巴厘岛值得信赖的租车服务",
    simple_booking: "简单的预订。可靠的车辆。卓越的服务。",
    we_provide_flexible: "我们提供灵活的租赁解决方案，包括自驾、司机服务和机场接送，旨在让您的巴厘岛之旅轻松无忧。",
  },
};

export default zh;
